<template>
  <div class="home-section" data-track="Portal-Home">
    <!-- Header Section Begins -->
    <div class="level page-info-section is-hidden-mobile">
      <div class="level-left page-layout-head">Home</div>
    </div> <!-- Header Section Ends -->
    <hr class="horizontal-row" />
    <div class="main-section">
      <div class="columns">
        <!-- Main content column Begins -->
        <div class="column content-section" :class="[{'full-layout': !sideStats.show}]">
          <div class="columns is-block intro">
            <div class="column padding-0 header">Hello {{user.name}},</div>
            <div class="column padding-0 para is-hidden-mobile">Here’s an overview of your account</div>
            <div class="column padding-0 para is-hidden-tablet is-hidden-desktop">For full experience login on desktop.</div>
          </div>
          <div class="main-section">
            <template v-for="(accordion, key, index) in mainSection.accordion" > <!--v-once-->
              <span class="grey-text" v-if="accordion.nextAction && accordion.visible">Your next action</span>
              <div class="grey-text grey-bottom-border-mobile more-actions" v-else-if="!accordion.nextAction && index===1 && accordion.visible">More actions</div>
              <Accordion :accordionType="key" v-if="accordion.visible" />
            </template>
          </div>
        </div> <!-- Main content column Ends -->
        <!--Side Stat Column-->
        <div class="column is-one-third side-stats" v-if="sideStats.show">
          <div class="section-header is-hidden-desktop is-hidden-tablet">
            <span class="msg">Review breakdown</span>
          </div>
          <!--Date range section Begins-->
          <div class="date-range is-hidden-mobile">
            <div class="has-text-weight-bold">Date range</div>
            <date-select-filter
              class="custom-dropdown"
              data-track="Portal Home Date Change Filter"
              :reviews_start_date="filters.dateFilter.reviews_start_date"
              :filter_items="filters.dateFilter.props"
              :styleProp="filters.dateFilter.styleProp"
              @onDateChange="handleDateChange"
            />
          </div>
          <!--Date range section Ends-->
          <!-- Side Accordion Begins -->
          <div class="stat-widget side-accordian-section" v-if="sideStats.appearance.unrepliedReviews.visible">
            <router-link to="/reviews?status=unreplied" data-track="Portal Home Reviews Lists">
              <div class="columns side-accordian is-mobile">
                <div class="column is-narrow stats-width padding-top-bottom-5">
                  <span class="bold-text">{{sideStats.reviewsStats.unrepliedReviews || 0}}</span>
                </div>
                <div class="column padding-top-bottom-5">
                  <span>Unreplied Reviews</span>
                </div>
                <div class="column is-narrow is-flex padding-top-bottom-5">
                  <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                </div>
              </div>
            </router-link>
          </div> <!-- Side Accordion Ends -->

          <!-- Side Accordion Begins -->
          <div class="stat-widget side-accordian-section" v-if="sideStats.appearance.unreadReviews.visible">
            <router-link to="/reviews?status=unread" data-track="Portal Home Reviews Lists">
              <div class="columns side-accordian is-mobile">
                <div class="column is-narrow stats-width padding-top-bottom-5">
                  <span class="bold-text">{{sideStats.reviewsStats.unreadReviews || 0}}</span>
                </div>
                <div class="column padding-top-bottom-5">
                  <span>Unread</span>
                </div>
                <div class="column is-narrow is-flex padding-top-bottom-5">
                  <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                </div>
              </div>
            </router-link>
          </div> <!-- Side Accordian Ends -->

          <!-- Side Accordion Begins -->
          <div class="stat-widget side-accordian-section" v-if="sideStats.appearance.inviteNotConverted.visible">
            <router-link to="/collect-reviews/review-invites/history" data-track="Portal Home Reviews Invite History">
              <div class="columns side-accordian is-mobile">
                <div class="column is-narrow stats-width padding-top-bottom-5">
                  <span class="bold-text">{{sideStats.emailInviteData.totalNonConverted || 0}}</span>
                </div>
                <div class="column padding-top-bottom-5">
                  <span>Review Invites not converted</span>
                </div>
                <div class="column is-narrow is-flex padding-top-bottom-5">
                  <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                </div>
              </div>
            </router-link>
          </div> <!-- Side Accordion Ends -->

          <!-- Average Star Rating Card Begins -->
          <div class="stat-widget columns avg-rating-card rating-card-desktop margin-0" v-if="sideStats.appearance.avgStarRating.visible">
            <div class="column rating-column">
              <average-rating-card :starRatings="sideStats.ratingData" :showTotal="true"></average-rating-card>
            </div>
          </div> <!-- Average Star Rating Card Ends -->

          <!-- Email invite widget Begins -->
          <div class="stat-widget columns" v-if="sideStats.appearance.emailInviteSent.visible">
            <div class="column padding-top-0">
              <email-invite-widget :inviteData="sideStats.emailInviteData" />
            </div>
          </div> <!-- Email invite widget Ends -->

          <!-- Industry ranking widget Begins -->
          <div class="stat-widget columns" v-if="sideStats.appearance.industryRanking.visible">
            <div class="column padding-top-0">
              <ranking-widget :attributes="sideStats.industryRankings" v-if="sideStats.industryRankings" />
            </div>
          </div> <!-- Industry ranking widget Ends -->

          <!-- Trust index widget Begins -->
          <div class="stat-widget columns" v-if="sideStats.appearance.trustIndex.visible">
            <div class="column padding-top-0">
              <ranking-widget :attributes="sideStats.trustIndexRankings" v-if="sideStats.trustIndexRankings" />
            </div>
          </div> <!-- Trust index widget Ends -->

          <!-- NPS widget Begins -->
          <div class="stat-widget columns margin-bottom-0" v-if="sideStats.appearance.npsScore.visible">
            <div class="column padding-top-0">
              <nps-score-widget :nps="sideStats.nps" />
            </div>
          </div> <!-- NPS widget Ends -->

          <!-- Response rate widget -->
          <div class="stat-widget columns" v-if="sideStats.appearance.responseRate.visible">
            <div class="column padding-top-0">
              <home-response-rate-widget :responseRates="sideStats.responseRateData" />
            </div>
          </div> <!-- Response rate widget -->
        </div>
        <!--Side Stat Column-->
      </div>
    </div>
    <!-- Confirmation Modal -->
    <ModalPopup
      title="Confirm deletion"
      body="Delete reply? This can't be undone."
      primaryBtnText="Cancel"
      secondaryBtnText="Delete"
      :secondaryBtnAction="handleDeleteReply"
    >
    </ModalPopup>
    <!-- Confirmation Modal -->
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc, no-unused-vars */
  import _ from 'lodash'
  import axios from 'axios'
  import moment from 'moment'
  import { misc } from '@/mixins'
  import Accordion from './Accordion'
  import {mapState, mapActions, mapMutations} from 'vuex'
  import {GMBModal, ModalPopup, AverageRatingCard, DateSelectFilter} from '@/components'
  import {RankingWidget, EmailInviteWidget, NpsScoreWidget, HomeResponseRateWidget} from '@/widgets'
  import { SHOW_MODAL, FETCH_REVIEW_ANALYTICS_GRAPH, FETCH_REVIEW_INVITE_ANALYTICS_STATS } from '@/store/action.types'
  import {SET_GMB_DATA} from '@/store/mutation.types'

  export default {
    name: 'Homepage',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Home'
    },
    mixins: [misc],
    components: {
      GMBModal,
      Accordion,
      ModalPopup,
      RankingWidget,
      NpsScoreWidget,
      DateSelectFilter,
      EmailInviteWidget,
      AverageRatingCard,
      HomeResponseRateWidget
    },
    data () {
      return {
        page: '',
        isLoading: false,
        toggleModal: false,
        forceUpdateKey: 0,
        business: null,
        businessDetails: null,
        replies: {
          id: null
        },
        quickReply: {
          name: null,
          email: null,
          mobile: null
        },
        errors: {
          quickReply: {
            name: null,
            email: null,
            mobile: null
          }
        },
        user: {
          name: `${localStorage.getItem('first_name')} ${localStorage.getItem('last_name')}`,
          businessSlug: localStorage.getItem('org_slug'),
          facebookPageId: '',
          originalLoginUrl: '',
          pageAccessToken: '',
          isAddTabButtonVisible: true,
          gmbSetup: null
        },
        sideStats: {
          show: false,
          ratingData: [],
          reviewsStats: [],
          nps: {
            score: 0,
            detractors: 0,
            passives: 0,
            promoters: 0
          },
          industryRankings: {},
          trustIndexRankings: {},
          responseRateData: {},
          emailInviteData: {},
          appearance: {
            unrepliedReviews: {visible: false},
            unreadReviews: {visible: false},
            inviteNotConverted: {visible: false},
            avgStarRating: {visible: false},
            emailInviteSent: {visible: false},
            industryRanking: {visible: false},
            trustIndex: {visible: false},
            npsScore: {visible: false},
            responseRate: {visible: false}
          }
        },
        filters: {
          dateFilter: {
            label: 'All time',
            endDate: null,
            startDate: null,
            reviews_start_date: '',
            lastTwelveStartDate: null,
            lastTwelveEndDate: null,
            props: [
              {
                name: 'date',
                label: 'Date',
                showApplyBtn: true,
                default: { type: 'months', value: 6, selected: 'All time' }, // moment.js placeholder in type
                disabled: [],
                elements: [
                  'Last 7 days',
                  'Previous month',
                  'Last 6 months',
                  'Last 12 months',
                  'All time',
                  'Custom'
                ]
              }
            ]
          }
        },
        mainSection: {
          accordion: {
            respondToReviews: {
              show: false,
              visible: false,
              reviews: {reviews: [], reviewsInfo: 0},
              nextAction: false,
              externalReviews: false,
              showInternalOptions: false,
              reviewsOption: {quickReplyButton: false, quickReplyBoxDesktop: false, quickReplyBoxMobile: false}
            },
            collectReviews: {
              show: false,
              visible: false,
              nextAction: false,
              showBulkInvite: false,
              invitedForReview: false,
              showSetupTemplate: false,
              showInternalOptions: false,
              showInternalQuickInvite: false,
              showExternalQuickInvite: false,
              showExternalQuickInviteHeader: ''
            },
            businessProfileSetup: {visible: false, show: false, nextAction: false},
            socialIntegration: {visible: false, show: false, nextAction: false},
            widgets: {visible: false, show: false, nextAction: false},
            googleReviews: {visible: false, show: false, nextAction: false, removeWidget: false}
            // reviewManagement: {visible: false, show: false, nextAction: false} // Uncomment when review management deployed by Vikas
          }
        }
      }
    },
    computed: {
      ...mapState({
        modalPopup: state => state.app.modal,
        analyticsData: state => state.analytics
      }),
      /**
       * Creating a payload for HTTP request
       * @return {object}
       */
      payload () {
        return {
          endDate: this.filters.dateFilter.endDate,
          startDate: this.filters.dateFilter.startDate,
          starRating: null,
          businessSlug: this.user.businessSlug
        }
      },
      /**
       * Check the user type whether it is having Paid plan
       * @return {boolean}
       */
      isPaidSubscription () {
        // If user having Other than Free business
        return this.userInfo.subscription.name !== 'Free'
      },
      /**
       * Is GMB Connected
       * @return {boolean}
       */
      isGMBConnected () {
        return !(this.user.gmbSetupgmbSetup && this.user.gmbSetupgmbSetup.data !== undefined && this.user.gmbSetupgmbSetup.data !== null && this.user.gmbSetupgmbSetup.data.distribution !== undefined)
      },
      /**
       * Check if app is in mobile view
       * @return {boolean}
       */
      isMobile () {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }
    },
    created () {
      if (this.$route.query.setup === 'true') {
        this.toggleModal = true
        this.page = 'locationSetup'
      }
      this.checkGMBSetup()
      this.getFacebookLoginUrl()
      this.getBusinessInfo()
      .then(() => {
        this.fetchInfoAboutHomepage()
      })
      window.events.$on('deleteReply', (replyId) => {
        this.replies.id = replyId
        this.showModal()
      })
      window.events.$on('updateAppearance', () => {
        this.getBusinessInfo()
        .then(() => {
          this.fetchInfoAboutHomepage()
        })
      })
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Portal-Home'
      })
      let dateTo = moment()
      let dateFrom = moment()
      dateTo.subtract(1, 'months').endOf('month')
      dateFrom.subtract(12, 'months').date(1)
      this.filters.dateFilter.lastTwelveStartDate = dateFrom.format('YYYY-MM-DD')
      this.filters.dateFilter.lastTwelveEndDate = dateTo.format('YYYY-MM-DD')
    },
    methods: {
      ...mapMutations({
        setGmbData: `gmb/${SET_GMB_DATA}`
      }),

      ...mapActions({
        showModal: `app/${SHOW_MODAL}`,
        fetchReviewAnalyticsGraph: `analytics/${FETCH_REVIEW_ANALYTICS_GRAPH}`,
        fetchReviewInvitesAnalytics: `analytics/${FETCH_REVIEW_INVITE_ANALYTICS_STATS}`
      }),
      /**
       * Method resetting the appearance of entire homepage to defaults
       * @return {void}
       */
      resetAppearanceToDefault () {
        _.each(this.sideStats.appearance, (appearance) => {
          appearance.visible = false
        })
        _.each(this.mainSection.accordion, (accordion, index) => {
          if (index === 'respondToReviews') {
            Object.assign(accordion, {
              show: false,
              visible: false,
              nextAction: false,
              externalReviews: false,
              showInternalOptions: false,
              reviewsOption: {quickReplyButton: false, quickReplyBoxDesktop: false, quickReplyBoxMobile: false}
            })
          } else if (index === 'collectReviews') {
            Object.assign(accordion, {
              show: false,
              visible: false,
              nextAction: false,
              showBulkInvite: false,
              invitedForReview: false,
              showSetupTemplate: false,
              showInternalOptions: false,
              showInternalQuickInvite: false,
              showExternalQuickInvite: false,
              showExternalQuickInviteHeader: ''
            })
          } else {
            Object.assign(accordion, {
              show: false,
              visible: false,
              nextAction: false
            })
          }
        })
      },
      /**
       * Method handling the appearance of entire homepage
       * @return {void}
       */
      updateAppearance () {
        this.resetAppearanceToDefault()
        let replied = 0
        let convertedCount = 0
        _.each(this.businessDetails.reviews, (obj) => {
          if (obj.replied) {
            ++replied
          }
          if (obj.invite) {
            ++convertedCount
          }
        })
        /**
         * Action 3A and its nesting
         * When a new user logged-in with 0 reviews and invites
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 0) {
          console.log(`In 3A`)
          Object.assign(this.mainSection.accordion.collectReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            invitedForReview: false,
            showExternalQuickInvite: true,
            showExternalQuickInviteHeader: `Lets get you collecting reviews`
          })
        }
        /**
         * Action 3A and its nesting
         * When did not sent any invites, got a review, replied
         * Coming after 1C completion
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 1 && !this.businessDetails.invitesInfo.totalInvites && replied === 1) {
          console.log(`In 3A`)
          Object.assign(this.mainSection.accordion.collectReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            invitedForReview: false,
            showExternalQuickInvite: true,
            showExternalQuickInviteHeader: `Lets get you collecting reviews`
          })
        }
        /**
         * Action 3B and its nesting
         * When invite sent, review is converted from email and replied
         * After completing 3A and 1A
         * Show collect reviews with Email invite Stat
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 1 && this.businessDetails.reviews[0].invite && this.businessDetails.reviews[0].invite.converted && replied === 1) {
          console.log(`In 3B`)
          this.sideStats.show = this.sideStats.appearance.emailInviteSent.visible = true
          Object.assign(this.mainSection.accordion.collectReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            invitedForReview: true,
            showExternalQuickInvite: true
          })
        }
        /**
         * Action 3C and its nesting
         * When invite sent, review is not converted from email, user directly gave review and replied
         * After completing 3A and 1B
         * Show collect reviews with Email invite Stat
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 1 && !this.businessDetails.reviews[0].invite && this.businessDetails.invitesInfo.totalInvites && replied === 1) {
          console.log(`In 3C`)
          this.sideStats.show = this.sideStats.appearance.emailInviteSent.visible = true
          Object.assign(this.mainSection.accordion.collectReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            invitedForReview: true,
            showExternalQuickInvite: true
          })
        }
        /**
         * Action 4A and its nesting for 1st Scenario
         * When 1st invite sent, review is converted from email, replied to 1st review and invite converted for 2nd review from email but not replied
         * After completing 3A, 1A, 3B or 3A, 1B, 3C
         * Show respond to reviews with quick reply box
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 2 && this.businessDetails.reviewsInfo.totalConverted === 2 && replied <= 1) {
          console.log(`In 4A`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 4A and its nesting for 2nd scenario
         * When 1st invite sent, review is not converted from email, replied to 1st review and invite converted for 2nd review from email but not replied
         * After completing 3A, 1A, 3B or 3A, 1B, 3C
         * Show respond to reviews with quick reply box
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 2 && this.businessDetails.reviewsInfo.totalConverted === 1 && replied === 1) {
          console.log(`In 4A`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 4B and its nesting
         * When 1st invite sent, review is not converted from email, replied to 1st review and invite converted for 2nd review but not from email and not replied
         * After completing 3A, 1B, 3C
         * Show respond to reviews with quick reply box
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 2 && !this.businessDetails.reviews[0].invite && replied === 1) {
          console.log(`In 4B`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 1A and its nesting
         * When invite sent, review is converted from email and not replied
         * After completing 3A
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 1 && this.businessDetails.reviews[0].invite && this.businessDetails.reviews[0].invite.converted && replied === 0) {
          console.log(`In 1A`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true
          })
        }
        /**
         * Action 1B and its nesting
         * When invite sent, review is not converted from email, yet user directly gave review and not replied
         * After completing 3A
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 1 && !this.businessDetails.reviews[0].invite && this.businessDetails.invitesInfo.totalInvites !== 0 && replied === 0) {
          console.log(`In 1B`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true
          })
        }
        /**
         * Action 1C and its nesting
         * When no invite sent, but received a review
         * If 3A not completed
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 1 && this.businessDetails.invitesInfo.totalInvites === 0 && replied === 0) {
          console.log(`In 1C`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true
          })
        }
        /**
         * Action 2A and its nesting
         * When sent 1st invite, got review converted from email and not replied, but got 2nd review without invite
         * If 1A not completed
         * (&& this.businessDetails.invitesInfo.totalInvites === 1) This condition removed, place it if not worked
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 2 && this.businessDetails.reviewsInfo.totalConverted === 1 && replied === 0) {
          console.log(`In 2A`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 2B and its nesting
         * When sent 1st invite, 1st review not converted from email and not replied, but got 2nd review without invite and not replied
         * If 1B not completed
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 2 && this.businessDetails.invitesInfo.totalInvites >= 1 && this.businessDetails.reviewsInfo.totalConverted === 0 && replied === 0) {
          console.log(`In 2B`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 2C and its nesting
         * When no invite sent, but received 2nd review
         * If 3A not completed
         */
        if (this.businessDetails.reviewsInfo.totalReviews === 2 && this.businessDetails.invitesInfo.totalInvites === 0 && replied === 0) {
          console.log(`In 2C`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 2C and its nesting
         * When user onboard with multiple organic reviews, no invites, no conversions, no replies
         * If 3A not completed
         */
        if (this.businessDetails.reviewsInfo.totalReviews >= 2 && this.businessDetails.reviewsInfo.totalConverted === 0 && this.businessDetails.reviewsInfo.totalReplied >= 0 && this.businessDetails.reviewsInfo.totalReplied < 2 && this.businessDetails.invitesInfo.totalInvites === 0) {
          console.log(`In 2C`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            visible: true,
            nextAction: true,
            externalReviews: true,
            reviewsOption: {
              quickReplyButton: true
            }
          })
        }
        /**
         * Action 5A/5B and its nesting
         * When there's 2 or more than 2 Reviews, all not converted from email and all or some replied
         * After completing 3A, 1B, 3C, 4B
         * Show entire side stats and Collect review only until single review is converted
         */
        if (this.businessDetails.reviewsInfo.totalReviews >= 2 && this.businessDetails.reviewsInfo.totalReplied >= 2 && this.businessDetails.reviewsInfo.totalConverted === 0) {
          console.log(`In 5A/5B`)
          this.sideStats.show = true
          _.each(this.sideStats.appearance, (appearance) => {
            appearance.visible = true
          })
          Object.assign(this.mainSection.accordion.collectReviews, {
            show: true,
            visible: true,
            nextAction: true,
            invitedForReview: true,
            showExternalQuickInvite: true
          })
          this.mainSection.accordion.collectReviews.show = (this.isMobile ? 0 : 1)
        }
        /**
         * Action 6 and its nesting
         * When 2 invites and both has been converted, both replied and biz profile not completed(Means logo not uploaded and address/email not provided) OR
         * When 2 invites and neither converted, both replied and then any one/more review is converted and biz profile not completed(Means logo not uploaded and address/email not provided)
         * After completing 3A, 1A, 3B, 2A|4A|5A
         * Show complete business profile and all widgets open plus show side stats
         */
        if (
          this.businessDetails.reviewsInfo.totalReviews >= 2 &&
          this.businessDetails.reviewsInfo.totalReplied >= 2 &&
          ((this.businessDetails.reviews[0].invite && this.businessDetails.reviews[1].invite) || (this.businessDetails.reviewsInfo.totalConverted >= 1)) &&
          (!this.businessDetails.business.org_logo || !(this.businessDetails.business.physical_address || this.businessDetails.business.org_url))
        ) {
          console.log(`In 6`)
          this.sideStats.show = true
          this.mainSection.accordion = _.omit(this.mainSection.accordion, ['collectReviews', 'respondToReviews'])
          this.mainSection.accordion.businessProfileSetup.nextAction = true
          _.each(this.sideStats.appearance, (appearance) => {
            appearance.visible = true
          })
          _.each(this.mainSection.accordion, (accordion) => {
            Object.assign(accordion, {
              show: (this.isMobile ? 0 : 1),
              visible: true
            })
          })
        }
        /**
         * Action 7 and its nesting
         * When 2 invites has been converted, both replied and biz profile completed(Means logo uploaded and address/email provided)
         * After completing 3A, 1A, 3B, 4A, 6
         * Show Social Integration and all widgets all open plus show side stats except collectReviews, respondToReviews, businessProfileSetup
         */
        if (this.businessDetails.reviewsInfo.totalReviews <= 2 && this.businessDetails.reviewsInfo.totalReplied <= 2 && (this.businessDetails.business.org_logo && (this.businessDetails.business.physical_address || this.businessDetails.business.org_url))) {
          console.log(`In 7`)
          this.sideStats.show = true
          this.mainSection.accordion = _.omit(this.mainSection.accordion, ['collectReviews', 'respondToReviews', 'businessProfileSetup'])
          this.mainSection.accordion.socialIntegration.nextAction = true
          _.each(this.sideStats.appearance, (appearance) => {
            appearance.visible = true
          })
          _.each(this.mainSection.accordion, (accordion) => {
            Object.assign(accordion, {
              show: (this.isMobile ? 0 : 1),
              visible: true
            })
          })
          this.checkGMBSetup()
        }
        /**
         * Action 8 and its nesting
         * Show all the main actions and side stats
         * This action is for existing user who have more than 2 reviews
         */
        if ((this.businessDetails.reviewsInfo.totalReviews > 2) && this.businessDetails.reviewsInfo.totalConverted !== 0) {
          console.log(`In 8`)
          Object.assign(this.mainSection.accordion.respondToReviews, {
            show: (this.isMobile ? 0 : 1),
            nextAction: true,
            showInternalOptions: true
          })
          Object.assign(this.mainSection.accordion.collectReviews, {
            show: (this.isMobile ? 0 : 1),
            showBulkInvite: this.isPaidSubscription,
            showSetupTemplate: !this.isPaidSubscription,
            showInternalOptions: true,
            showInternalQuickInvite: this.isPaidSubscription
          })
          /** If user had replied all its reviews, then direct it collect more reviews by moving Collect Reviews on top */
          if (this.businessDetails.reviewsInfo.totalReviews === this.businessDetails.reviewsInfo.totalReplied) {
            let swapRespondToCollectReviews = []
            let tempObj = Object.keys(this.mainSection.accordion)
            _.each(tempObj, (obj, key) => {
              if (key === 0) {
                swapRespondToCollectReviews['collectReviews'] = this.mainSection.accordion['collectReviews']
              } else if (key === 1) {
                swapRespondToCollectReviews['respondToReviews'] = this.mainSection.accordion['respondToReviews']
              } else {
                swapRespondToCollectReviews[obj] = this.mainSection.accordion[obj]
              }
            })
            this.mainSection.accordion = Object.assign({}, swapRespondToCollectReviews)
            this.mainSection.accordion.collectReviews.nextAction = true
            this.mainSection.accordion.respondToReviews.nextAction = false
          }
          /** If business don't have logo and (Address OR Website), then ask them to complete */
          if (!this.businessDetails.business.org_logo || !(this.businessDetails.business.physical_address || this.businessDetails.business.org_url)) {
            this.mainSection.accordion.businessProfileSetup.show = true
          }
          this.sideStats.show = true
          _.each(this.sideStats.appearance, (appearance) => {
            appearance.visible = true
          })
          _.each(this.mainSection.accordion, (obj, index) => {
            this.mainSection.accordion[index].visible = true
          })
        }
      },
      /**
       * Get details about Business/reviews for Homepage apperance
       * @return {void}
       */
      fetchInfoAboutHomepage () {
        axios.get(`${this.user.businessSlug}/homepage-details`)
        .then(({data}) => {
          this.mainSection.accordion.respondToReviews.reviews = this.businessDetails = data.data
          this.updateAppearance()
        })
      },
      /**
       * Open modal action
       * @param {string} tabName
       * @return {void}
       */
      openModal (tabName) {
        if (this.isPaidSubscription) {
          this.toggleModal = !this.toggleModal
        }
      },
      /**
       *  Redirect to renew or upgrade page
       *  @returns {void}
       */
      renewOrUpgrade () {
        this.$router.push('/renew-or-upgrade-subscription')
      },
      /**
       * Fetching the review analytics stats
       * @return {void}
       */
      fetchAnalyticsStats () {
        const payload = {
          source: ['WEBSITE'],
          endDate: this.filters.dateFilter.endDate,
          startDate: this.filters.dateFilter.startDate,
          dateInterval: this.customLabel(
            this.filters.dateFilter.startDate,
            this.filters.dateFilter.endDate
          ),
          businessSlug: this.user.businessSlug,
          newEp: true
        }
        this.fetchReviewAnalyticsGraph(payload)
        .then((data) => {
          this.sideStats.ratingData = data.common.ratingData
          this.sideStats.responseRateData = data.common.responseRateData
          this.sideStats.responseRateData['avgReplyTime'] = data.common.chartAvgReplyTime
          this.sideStats.reviewsStats = data.common.reviewsStats
        })
      },
      /**
       * Get basic information about business
       * @return {Promise}
       */
      getBusinessInfo () {
        return new Promise((resolve) => {
          axios.get(`business/${this.user.businessSlug}/info`)
          .then(({data}) => {
            this.business = data.data
            this.filters.dateFilter.reviews_start_date = data.data.review.firstReview ? moment(data.data.review.firstReview.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            this.user.facebookPageId = data.data.business.facebook_page_id
            // this.user.pageAccessToken = data.data.business.long_lived_page_access_token
            this.user.isAddTabButtonVisible = !this.user.pageAccessToken
            resolve(data.data)
          })
          .catch((error) => {
            flash(`${error.message}`, 'is-danger')
          })
        })
      },
      /**
       * Get statistics for Industry/TrustIndex ranking
       * @return {Promise}
       */
      getRankingsStats () {
        return new Promise((resolve, reject) => {
          axios.get(`consumer/business-stats/${this.user.businessSlug}`, {
            params: {
              startDate: this.filters.dateFilter.lastTwelveEndDate,
              endDate: this.filters.dateFilter.lastTwelveStartDate
            }
          })
          .then(({data}) => {
            this.sideStats.industryRankings = {
              positions: [],
              growth: 0,
              showGrowth: 0,
              header: {
                title: 'Industry ranking',
                subtitle: '(last 12 months)'
              },
              texts: {
                leftText: `<span style="font-size: 18px; font-weight: bold;">0 </span> places`,
                rightText: `<span style="font-size: 18px; font-weight: bold;">#${data.monthlyStats.industryRanking}</span> in ${data.monthlyStats.industrySlug}`
              }
            }
            this.sideStats.trustIndexRankings = {
              positions: [],
              growth: parseInt(data.rankings.trust_index_sensex) > 0,
              showGrowth: parseInt(data.rankings.trust_index_sensex) !== 0,
              header: {
                title: 'Trustindex',
                subtitle: '(last 12 months)'
              },
              texts: {
                leftText: `<span style="font-size: 18px; font-weight: bold;">${parseInt(data.rankings.trust_index_sensex)} %</span>`,
                rightText: `<span style="font-size: 18px; font-weight: bold;">${data.monthlyStats.trustIndex}</span> out of 10`
              }
            }
            data.monthlyStats.months.forEach((val, key) => {
              if (key !== 3) {
                this.sideStats.industryRankings.positions.push({
                  month: val.month,
                  stat: val.industryRanking ? `# ${val.industryRanking}` : ''
                })
                this.sideStats.trustIndexRankings.positions.push({
                  month: val.month,
                  stat: val.trustIndex ? `# ${val.trustIndex}` : ''
                })
              }
            })
            resolve(data)
          })
          .catch((error) => {
            reject(error)
            flash(`${error.message}`, 'is-danger')
          })
        })
      },
      /**
       * Handle Date Dropdown Filter
       * @param {object} dateFilter Date data to sort on
       * @return {void}
       */
      handleDateChange (dateFilter) {
        Object.assign(this.filters.dateFilter, dateFilter)
        if (dateFilter.label === 'all_time') {
          this.getBusinessInfo()
          .then(() => {
            this.filters.dateFilter.startDate = this.filters.dateFilter.reviews_start_date
            this.filters.dateFilter.endDate = moment().format('YYYY-MM-DD')
            this.fetchAnalyticsStats()
            this.fetchNpsStats()
            this.fetchInviteStats()
            this.getRankingsStats()
          })
        } else {
          this.fetchAnalyticsStats()
          this.fetchNpsStats()
          this.fetchInviteStats()
          this.getRankingsStats()
        }
      },
      /**
       * Fetching the review analytics stats
       * @return {void}
       */
      fetchNpsStats () {
        axios.get(`/analytics/${this.user.businessSlug}/nps`, {
          params: this.payload
        })
        .then(({data}) => {
          Object.assign(this.sideStats.nps, data.data.npsData, {
            score: data.data.npsData.nps_total
          })
        })
      },
      /**
       * Fetching the review invite stats
       * @return {void}
       */
      fetchInviteStats () {
        this.fetchReviewInvitesAnalytics(this.payload)
        .then((data) => {
          this.sideStats.emailInviteData = data.stats
        })
      },
      /**
       * Fetching the appearance of side stats filters
       * @param {String} option
       * @return {void}
       */
      handleAccordion (option) {
        if (!this.mainSection.accordion[option].nextAction || this.isMobile) {
          this.mainSection.accordion[option].show = !this.mainSection.accordion[option].show
        }
      },
      /**
       * Add new tab on hellopeter facebook page
       * @param {Object} event
       * @return {void}
       */
      addFacebookTab (event) {
        if (!this.user.facebookPageId && this.user.pageAccessToken) {
          window.open(this.user.originalLoginUrl)
        }
      },
      /**
       * Remove tab from facebook page
       * @returns {void}
       **/
      removeFacebookTab () {
        if (this.user.isAddTabButtonVisible) {
          axios.post(`/${this.user.businessSlug}/remove-facebook-page-tab`)
          .then(() => {
            dataLayer.push({
              'userMessage': {
                'messageType': 'success',
                'messageName': 'Facebook tab removed successfully',
                'displayedMessage': 'Facebook tab removed successfully'
              }
            })
            location.reload()
          })
          .catch((error) => {
            this.displayErrMsg(error, 'Failed removing facebook page tab', 'Oops, something went wrong. Please try reloading or contact our administrator')
          })
        }
      },
      /**
       * Get facebook login url
       * @returns {void}
       **/
      getFacebookLoginUrl () {
        axios.get(`/social/fb/${this.user.businessSlug}/get-integration`)
        .then(({data}) => {
          this.user.originalLoginUrl = data.original_login_url
          this.user.pageAccessToken = data.data.token
        })
        .catch((error) => {
          console.log(error.response.data.message)
        })
      },
      /**
       * Handle quick invite
       * @returns {void}
       **/
      handleQuickInvite () {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        _.forIn(this.errors.quickReply, (value, key) => {
          if (!this.quickReply[key] && key !== 'mobile') {
            this.errors.quickReply[key] = `${key[0].toUpperCase()}${key.slice(1)} required`
          } else {
            this.errors.quickReply[key] = null
            if (key === 'email' && !regex.test(String(this.quickReply[key]).toLowerCase())) {
              this.errors.quickReply[key] = `${key[0].toUpperCase()}${key.slice(1)} is not valid`
            }
          }
        })
        /** If its passed all validations */
        if (_.values(this.errors.quickReply).every(_.isEmpty)) {
          this.isLoading = true

          axios.post(`/${this.businessId}/review-invites/send-invite`, {
            bizSlug: this.user.businessSlug,
            firstName: this.quickReply.name,
            email: this.quickReply.email,
            number: this.quickReply.mobile
          })
            .then(_ => {
              this.isLoading = false
              Object.keys(this.quickReply).forEach((key) => { this.quickReply[key] = null })
              this.displaySuccessMsg(`Invite sent successfully`)
              this.getBusinessInfo()
                .then(() => {
                  this.fetchInviteStats()
                  this.fetchInfoAboutHomepage()
                })
              dataLayer.push({
                'userMessage': {
                  'messageType': 'success',
                  'messageName': 'Mail sent successfully to invite user.',
                  'displayedMessage': 'Mail sent successfully to invite user.'
                }
              })
            })
            .catch((error) => {
              this.displayErrMsg(error, 'Failed in sending mail', 'Oops, something went wrong. Please try reloading or contact our administrator')
            })
        }
      },
      /**
       * Handle delete reply
       * @returns {void}
       */
      handleDeleteReply () {
        axios.delete(`reviews/delete-review-reply/${this.replies.id}`)
        .then(({data}) => {
          this.showModal(false)
          this.fetchInfoAboutHomepage()
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully deleted the reply',
              'displayedMessage': 'Successfully deleted the reply'
            }
          })
          flash('Successfully deleted the reply.', 'is-success')
        })
      },
      /**
       * Check if GMB connection is established for user
       * @returns {void}
       */
      checkGMBSetup () {
        axios.get(`/social/gmb/check-gmb-setup/${this.user.businessSlug}`)
        .then(({data}) => {
          this.setGmbData(data.data)

          this.user.gmbSetupgmbSetup = data.data
          if (this.user.gmbSetupgmbSetup.data !== undefined && this.user.gmbSetupgmbSetup.data !== null && this.user.gmbSetupgmbSetup.data.distribution !== undefined) {
            this.mainSection.accordion.googleReviews.show = false
            this.mainSection.accordion.googleReviews.removeWidget = true
          }
        })
        .catch(() => {
          this.mainSection.accordion.googleReviews.show = true
          this.mainSection.accordion.googleReviews.removeWidget = false
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
$text-color: #58595b;
$link-color: #30aae1;
$blue-text-color: #1261a0;

.page-layout {
  margin-left: 0;
}
.page-layout .page-layout-head {
  font-size: 12px;
}
.page-info-section {
  color: #58595b;
  font-size: 12px;
  padding: 0 25px 0 15px;
  margin-bottom: 0.8rem;

  .page-layout-head {
    font-weight: bold;
  }
}
.header-filters {
  justify-content: flex-end;
}
.horizontal-row {
  margin-top: 0;
  margin-bottom: 1rem;
  margin-left: -5%;
  margin-right: -5%;
}
.has-text-weight-bold {
  color: $text-color;
  font-size: 12px;
}
.side-stats {
  /*width: 28%;*/
  width: 295px;
  padding: 0 0 10px 0;
  padding-top: 0;
  padding-left: 0;
  border-left: solid 1px rgba(88,89,91,0.32);

  .stat-widget:last-of-type {
    margin-bottom: 10px;
  }
  .date-range {
    margin: 0 0 12px 0;
    padding: 20px 10px 30px 10px;
    border-bottom: solid 1px rgba(88, 89, 91, 0.32);
    background-color: #fafafa;

    .custom-dropdown {
      margin: 0;
      padding: 12px 0;

      >>>.button.button-dropdown img {
        height: 17px;
        padding: 0;
      }
    }
  }
  .avg-rating-card {
    .rating-column {
      padding: 15px 10px;
    }
    >>>.card-text {
      font-size: 12px;
    }
  }
  .response-rates {
    .response-rate {
    }
  }
  .section-header {
    color: #58595b;
    opacity: 0.6;
    margin: 5px 12px;
    padding: 5px 12px 5px 0;
    font-size: 11px;
    border-bottom: 2px solid #dbdbdb;
    text-transform: uppercase;

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      font-size: 12px;
    }
  }
  /*Mobile view*/
  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 8px;
    margin-bottom: 25px;
  }
}
.side-accordian-section {
  color: $text-color;
  padding: 10px 9px 15px 13px;

  .side-accordian {
    padding: 10px 0px 10px 10px;
    font-size: 12px;
    align-items: center;
    border: solid 1px rgba(88, 89, 91, 0.32);

    .bold-text {
      font-size: 12px;
      font-weight: bold;
    }
    .stats-width {
      width: 13%;
    }
  }
  a {
    color: $text-color;
  }
  .internal-link {
    color: rgba(88, 89, 91, 0.32);
    text-decoration: underline;
  }
}
.content-section {
  padding: 20px 30px;

  &.full-layout {
    padding: 20px 145px;

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      padding: 20px 30px;
    }
  }
  .intro {
    margin: 0 0 25px 0;

    .header {
      color: #1261a0;
      font-size: 18px;
      font-weight: bold;
    }
    .para {
      color: #58595b;
      font-size: 14px;
    }
  }
  .main-section {
    .accordian-container {
      border: solid 1px rgba(88, 89, 91, 0.32);

      &:last-of-type {
        margin-bottom: 5px;
      }
      .columns {
        margin: 0;
      }
      .content {
        color: $text-color;
        padding: 5px 20px 5px 50px;
        font-size: 12px;
      }
      .side-accordian {
        padding: 5px 10px;
      }
      .grey-text {
        color: #707070;
        font-size: 12px;
        opacity: 0.6;
        text-transform: uppercase;
      }
      .popular-widget-section {
        border-bottom: solid 1px rgba(88, 89, 91, 0.32);
      }
      .widgets {
        /*Mobile view*/
        @media screen and (max-width: 767px) {
          width: 100%;
        }
      }
      .google-connect-column {
        width: 38%;
        flex: 0 0 20%;
        padding: 0 12px 0 0;

        .google-connect-box {
          -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
          border: solid 1px rgba(216, 216, 216, 0.32);
          width: 215px;

          .img {
            padding: 20px 60px;
            background: url('/static/img/review-invites/mask-group-267.png');

            span {
              display: none;
            }
          }

          div {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          strong {
            font-size: 12px;
            line-height: 20px;
            display: block;
            text-align: center;
            margin: 17px 0;
          }

          .text-row {
            text-align: center;
          }

          .connect-btn {
            font-size: 12px;
            color: #fff;
            background: #1261a0;
            width: 130px;
            margin: 0 0 15px;
          }

          .disabled-connect {
            opacity: 0.7;
            background: #cdcbcb;
          }

          .disabled-img-box {
            position: relative;
            text-align: center;
          }

          .lock-wrapper {
            display: none;
          }

          .disabled-img-box {
            span {
              display: block;
              font-size: 14px;
              line-height: 19px;
              color: #fff;
              position: absolute;
              top: 72%;
              left: 0;
              width: 100%;
            }

            .lock-wrapper {
              position: absolute;
              top: 25%;
              display: block;
              width: 100%;
              left: 0;
            }

            .gmb-lock {
              width: 100%;
              max-width: 21px;
              height: auto;
            }
          }

          /*Mobile view*/
          @media screen and (max-width: 767px) {
            width: 100%;
          }
        }

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          width: 100%;
          margin: 0 0 20px 0;
          padding-right: 0;
        }
      }
      .location-not-verified {
        border: 1px solid #E4862C;
        color: #E4862C;
        font-size: 12px;

        .exclamation-sign {
          align-items: center;
          justify-content: center;
          display: flex;
          border-right: 1px solid #E4862C;

        }
      }
      .review-management-section {
        .app-name {
          width: 12%;
        }
        .logo {
          width: 4%;
        }
        .connected-text {
          color: rgba(88, 89, 91, 0.4);
          text-decoration: none;
          cursor: none;
        }
      }
      .connect-social-accounts {
        font-size: 11px;

        .social-heading {
          font-size: 12px;
        }
      }
      .dot {
        height: 5px;
        width: 5px;
        border-radius: 50%;
        display: inline-flex;

        &.facebook {
          background-color: #f99c50;
        }
        &.social-ad {
          background-color: $blue-text-color;
        }
      }
    }
  }

  /*Mobile view*/
  @media screen and (max-width: 767px) {
    padding: 20px;
    border-right: none;
  }
}
.blue-text {
  color: $blue-text-color;
  font-size: 14px;
  font-weight: bold;
}
.link {
  color: $link-color;
  text-decoration: underline;
}
.cursor {
  cursor: pointer;
}
.button {
  width: 130px;
  height: 35px;
  text-transform: uppercase;

  &.button-orange {
    color: #f99c50;
    border: solid 1px #f99c50;
  }
  &.button-dark-blue {
    color: $blue-text-color;
    border: solid 1px $blue-text-color;
  }
}
.grey-text {
  color: rgba(88, 89, 91, 0.5);
  opacity: 1;
  margin: 10px 0;
  font-size: 12px;
  text-transform: uppercase;

  &.more-actions {
    margin-bottom: 0;
  }
}
.grey-bottom-border-mobile {
  /*Mobile view*/
  @media screen and (max-width: 767px) {
    color: #58595b;
    opacity: 0.6;
    font-size: 12px;
    border-bottom: 2px solid #dbdbdb;
  }
}
/* Helper css begins */
.margin {
  &-0 {
    margin: 0;
  }
  &-bottom {
    &-0 {
      margin-bottom: 0;
    }
  }
}
.padding {
  &-0 {
    padding: 0;
  }
  &-top {
    padding-top: 0;

    &-bottom {
      &-5 {
        padding: 0 5px;
      }
    }
  }
}
.flex {
  &-80 {
    flex: 80%;
  }
}
/* Helper css ends */
</style>
<!-- Global CSS Begins -->
<style>
  div#sideBar .is-padding-top-0 {
    padding-top: 0;
  }
  div#sideBar .is-full-width-view {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  div#sideBar .is-full-width-view .horizontal-row {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Homepage.vue